import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const removeCookies = () => {
  const cookiesToRemove = ['PHPSESSID', 'userID'];
  cookiesToRemove.forEach((cookieName) => {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

const useUserStore = create(
  persist(
    (set) => ({
      user: null,
      saveUser: (user) => set({ user }),
      logout: () => {
        removeCookies();
        set({ user: null });
      },
    }),
    { name: 'lt-user', storage: createJSONStorage(() => sessionStorage) } // (optional) by default, 'localStorage' is used
  )
);

export default useUserStore;
